import type { MenuStoryblok } from "@/types/storyblok-blok-types";
import { useEffect, useState } from "react";

export function useCuratedTabs(menu: MenuStoryblok | null) {
  const [activeUid, setActiveUid] = useState<string | null>(() =>
    menu?.title?.toLowerCase() === "curated" && menu.section?.[0]?._uid
      ? menu.section[0]._uid
      : null
  );

  useEffect(() => {
    if (
      menu?.title?.toLowerCase() === "curated" &&
      menu.section?.length &&
      !activeUid
    ) {
      setActiveUid(menu.section[0]._uid);
    }
  }, [menu, activeUid]);

  return { activeUid, setActiveUid };
}
